export default __webpack_public_path__ + "static/media/Artboard 5.e61c9f45.png";